import React from 'react'
import ContactUs from '../feature/ContactUs/ContactUs'
import { ToastContainer } from "react-toastify";

const ContactUsPage = () => {
  return (
    <>
        <ToastContainer />
        <ContactUs/>
    </>

  )
}

export default ContactUsPage